export default {
    name: 'ContextBrowser',
    file: 'browser',
    properties: {
        user_agent: {},
        device: {},
        app_type: {},
    },
};
